import { ComponentRef, EventEmitter } from '@angular/core';

import { Observable } from 'rxjs';

import { NotificationBodyBase } from './notification-body-base';
import { NotificationConfig, NotificationStyle } from './notification-config';
import { NotificationHostBase } from './notification-host-base';

export class NotificationRef<
  NotificationBody extends NotificationBodyBase = NotificationBodyBase,
  NotificationHost extends NotificationHostBase = NotificationHostBase,
> {
  public bodyRef: ComponentRef<NotificationBody>;
  public groupIdentifier?: string;
  public host?: any;
  public config?: NotificationConfig;
  private _hostRef: ComponentRef<NotificationHost>;

  public set hostRef(ref: ComponentRef<NotificationHost>) {
    ref.location.nativeElement.classList.add('notification-component-host');
    this._hostRef = ref;
  }

  public get hostRef(): ComponentRef<NotificationHost> {
    return this._hostRef;
  }

  public onClick(): EventEmitter<any> {
    return this.hostRef.instance.hostClick;
  }

  public topButtonClick(): EventEmitter<void> {
    return this.hostRef.instance.topButtonClick;
  }

  public close(): void {
    this.hostRef.instance.close();
    this.hostRef.instance.afterClosed.subscribe(() => this.hostRef.destroy());
  }

  public get beforeClose(): Observable<any> {
    return this.hostRef.instance.beforeClose;
  }

  public get afterClosed(): Observable<any> {
    return this.hostRef.instance.afterClosed;
  }

  public set style(style: NotificationStyle) {
    this.hostRef.instance.setStyle(style);
  }

  public set title(title: string) {
    this.bodyRef.instance.setTitle(title);
  }

  public get title(): string {
    return this.bodyRef.instance.title!;
  }

  public set message(message: string) {
    this.bodyRef.instance.setMessage(message);
  }

  public get message(): string {
    return this.bodyRef.instance.message!;
  }

  public set messageHTML(messageHTML: string) {
    this.bodyRef.instance.setMessageHTML(messageHTML);
  }

  public get messageHTML(): string {
    return this.bodyRef.instance.messageHTML!;
  }
}
